import {requestContext} from '../../../../common/requestContext';
import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {CommonGroupProps} from '../../type';

function StandaloneBannerAndSubCard({children}: CommonGroupProps) {
  const {isMobile} = requestContext.requestInfo.display;
  return (
    // 태블릿 이상 환경에서는 배너 | 카드리스트 형태로 보여줘야 합니다.
    <Grid cols={isMobile ? 1 : 2} foldableCols={2} gapPx={3}>
      {children}
    </Grid>
  );
}

export default StandaloneBannerAndSubCard;
